import React from "react";

const ProfileDataRow = ({
    label,
    value,
}: {
    label: string;
    value: string | number | boolean | null;
}) => {
    return (
        <div className="flex flex-column md:flex-row align-items-start mb-3">
            <div className="md:w-3 w-full">
                <div className="text-left p-1 border-round-sm bg-primary font-bold ">{label}</div>
            </div>
            <div className="md:w-9 w-full">
                <div className="text-left p-1 border-round-sm bg-primary ">{value}</div>
            </div>
        </div>
    );
};

export default ProfileDataRow;